import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DataListPage from "../../../components/DataListPage";
import TruncatedCell from "../../../components/TruncatedCell";
import knowledgeService from "../../../services/knowledgeService";
import { instanceToken } from "../../../utils/constant";

export default function Knowledges() {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);
  const [knowledges, setknowledges] = useState(null);

  useEffect(() => {
    fetchknowledges(rowsPerPage, offset);
  }, [offset, rowsPerPage]);

  const fetchknowledges = async (limit, offset) => {
    try {
      const res = await knowledgeService.getKnowledges(
        instanceToken.token,
        limit,
        offset
      );
      parse(res.data);
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  };

  const parse = (data) => {
    setknowledges(data.knowledges);
    setCount(data.count);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setOffset(rowsPerPage * newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    setOffset(0);
  };

  const openDetail = (row) => navigate(`/knowledges/${row.id}`);

  const columns = [
    { id: "id", label: "ID", render: (row) => row.id },
    {
      id: "title_en",
      label: "Title (English)",
      render: (row) => <TruncatedCell value={row.title_en} />,
    },
    {
      id: "title_mm",
      label: "Title (Myanmar)",
      render: (row) => <TruncatedCell value={row.title_mm} myanmar />,
    },
    {
      id: "paragraph_en",
      label: "Paragraph (English)",
      render: (row) => <TruncatedCell value={row.paragraph_en} />,
    },
    {
      id: "paragraph_mm",
      label: "Paragraph (Myanmar)",
      render: (row) => <TruncatedCell value={row.paragraph_mm} myanmar />,
    },
  ];

  return (
    <DataListPage
      title="Knowledges"
      rows={knowledges || []}
      columns={columns}
      count={count}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      createButton={{
        label: "Create",
        onClick: () => navigate("/createKnowledge"),
      }}
      onView={openDetail}
      menuActions={[{ label: "View details", onClick: openDetail }]}
      loading={!knowledges}
    />
  );
}
